import axios from 'axios';
import { ROOT_API_URL } from '../../../api-config';
import { loader, toastr } from '../CommonActions';
import { auth } from '../../../services/auth.service';

export const GET_ALL_PRODUCTS = 'GET_ALL_PRODUCTS';
export const SAVE_PRODUCT = 'SAVE_PRODUCT';
export const DELETE_PRODUCT = 'DELETE_PRODUCT';

const successColor = 'success';
const errorColor = 'danger';
//const warningColor = 'warning';

export function fetchAllProducts() {
	return function(dispatch) {
		dispatch(loader(true));
		axios
			.get(`${ROOT_API_URL}/ManageProducts/GetAllProducts`, { headers: auth.authHeader() })
			.then((response) => {
				dispatch({
					type: GET_ALL_PRODUCTS,
					payload: response.data
				});
				dispatch(loader(false));
			})
			.catch((response) => {
				var err = response && response.data ? response.data.message : 'Network Connection Error';
				dispatch(loader(false));
				dispatch(toastr(true, err, errorColor));
			});
	};
}

export function saveProduct(model) {
	return function(dispatch) {
		dispatch(loader(true));
		axios
			.post(`${ROOT_API_URL}/ManageProducts/SaveProduct`, model, { headers: auth.authHeader() })
			.then(function(response) {
				if (response && response.data && response.data.issuccess) {
					dispatch({
						type: SAVE_PRODUCT,
						payload: response.data.products
					});
					var success = response && response.data ? response.data.message : 'Product Created Successfully';
					dispatch(toastr(true, success, successColor));
				} 
				dispatch(loader(false));
			})
			.catch((response) => {
				var err = response && response.data ? response.data.message : 'Network Connection Error';
				dispatch(loader(false));
				dispatch(toastr(true, err, errorColor));
			});
	};
}

export function deleteProduct(model) {
	return function(dispatch) {
		dispatch(loader(true));
		axios
			.post(`${ROOT_API_URL}/ManageProducts/DeleteProduct`, model, { headers: auth.authHeader() })
			.then(function(response) {
				if (response && response.data && response.data.issuccess) {
				dispatch({
					type: DELETE_PRODUCT,
					payload: response.data.products
				});
				var success = response && response.data ? response.data.message : 'Product Created Successfully';
					dispatch(toastr(true, success, successColor));
				} 
				dispatch(loader(false));
			})
			.catch((response) => {
				var err = response && response.data ? response.data.message : 'Network Connection Error';
				dispatch(loader(false));
				dispatch(toastr(true, err, errorColor));
			});
	};
}
